import {BaseVMeterCollection} from "./_BaseVMeterCollection";

export class VMeterGroupCollection extends BaseVMeterCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/app/' +  this.appUrlRoot + '/vmeter_groups';
    };

    comparator = (model) => {
        return model.get('name');
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/vmeter/collections/VMeterGroups.ts